const matchMedia = globalThis["matchMedia"];
export {
  matchMedia
};
//# sourceMappingURL=matchMedia.js.map
